var React = require('react');

function Rain (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M342.947 1349.02L3.20605 341.162M299.344 1036.53L45.4348 283.301M328.655 940.354L114.074 303.788M436.624 1077.51L156.306 245.928M508.033 1106.21L211.741 227.241M547.495 1040.13L267.176 208.555M580.142 953.848L335.815 229.041M658.365 1002.76L378.046 171.181M706.665 962.908L446.686 191.668M812.472 1093.65L488.917 133.807M833.584 973.142L557.557 154.294M873.504 908.427L599.787 96.4339M965.252 997.467L668.427 116.92M1047.1 1057.13L710.658 59.0603M1069.41 940.185L779.297 79.5469M1081.4 792.605L821.528 21.6868M1085.72 622.301L876.963 3","stroke":"#9EE2FF","strokeWidth":"5.3","strokeLinecap":"round","strokeDasharray":"40 30"}));
}

Rain.defaultProps = {"width":"1089","height":"1352","viewBox":"0 0 1089 1352","fill":"none"};

module.exports = Rain;

Rain.default = Rain;
